<template>
  <div class="page">
    <Head></Head>
    <workshop1Pc v-if="!isPhone&&index==1"></workshop1Pc>
    <workshop2Pc v-if="!isPhone&&index==2"></workshop2Pc>
    <workshop3Pc v-if="!isPhone&&index==3"></workshop3Pc>
    <workshop4Pc v-if="!isPhone&&index==4"></workshop4Pc>
    <workshop5Pc v-if="!isPhone&&index==5"></workshop5Pc>
    <workshop1Mobile v-if="isPhone&&index==1"></workshop1Mobile>
    <workshop2Mobile v-if="isPhone&&index==2"></workshop2Mobile>
    <workshop3Mobile v-if="isPhone&&index==3"></workshop3Mobile>
    <workshop4Mobile v-if="isPhone&&index==4"></workshop4Mobile>
    <workshop5Mobile v-if="isPhone&&index==5"></workshop5Mobile>
    <Foot></Foot>
  </div>
</template>

<script>
import Head from "@/components/header-index.vue";
import Foot from "@/components/footer-index.vue";
import workshop1Pc from "./workshop1Pc.vue";
import workshop2Pc from "./workshop2Pc.vue";
import workshop3Pc from "./workshop3Pc.vue";
import workshop4Pc from "./workshop4Pc.vue";
import workshop5Pc from "./workshop5Pc.vue";
import workshop1Mobile from "./workshop1Mobile.vue";
import workshop2Mobile from "./workshop2Mobile.vue";
import workshop3Mobile from "./workshop3Mobile.vue";
import workshop4Mobile from "./workshop4Mobile.vue";
import workshop5Mobile from "./workshop5Mobile.vue";
export default {
  components: {
    Head,
    Foot,
    workshop1Pc,
    workshop2Pc,
    workshop3Pc,
    workshop4Pc,
    workshop5Pc,
    workshop1Mobile,
    workshop2Mobile,
    workshop3Mobile,
    workshop4Mobile,
    workshop5Mobile
  },
  data() {
    return {
      isPhone: false,
      index: 1
    };
  },
  watch: {
    index() {
      this.setTitle();
    }
  },
  mounted() {
    this.index = this.$route.query.index || 1;
    // 判断是否手机
    this.getIsPhone();
    // 设置标题
    this.setTitle();
  },
  methods: {
    getIsPhone() {
      var userAgentInfo = navigator.userAgent;
      var Agents = [
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod"
      ];
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          this.isPhone = true;
        }
      }
    },
    setTitle() {
      let title = {
        1: "冲压车间",
        2: "车身车间",
        3: "油漆车间",
        4: "总装车间",
        5: "电池车间"
      };
      document.title = title[this.index];
    }
  }
};
</script>

<style lang="less" scoped>
</style>


